import { useDispatch, useSelector } from 'react-redux';
import { fetchCoordinators } from '../../redux/practice/practiceSlice';

import { RootState } from '../../redux/index';
import { useCallback } from 'react';

const useFetchIntakeCoordinator = () => {
    const dispatch = useDispatch();
    const { coordinators, isLoading } = useSelector((state: RootState) => state.practices);

    const fetchIntakeCoordinator = useCallback((practiceId: string) => {
        dispatch(fetchCoordinators(practiceId) as any);
    }, [dispatch]);

    return { coordinators, isLoading, fetchIntakeCoordinator }
}

export default useFetchIntakeCoordinator